import { Injectable } from "@angular/core";
import { Router, RouterStateSnapshot } from "@angular/router";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { map } from "rxjs";
import { AuthenticationService } from "../services/authentication.service";
import { LoggingService } from "../services/logging.service";

@Injectable({ providedIn: 'root' })
export class GuardHelper {

  constructor(private oidcSecurityService: OidcSecurityService, private authenticationService: AuthenticationService, private loggingService: LoggingService, private router: Router) {};


  checkAuthenticatedRole(role: string | null, state: RouterStateSnapshot) {
    return this.oidcSecurityService.isAuthenticated$.pipe(
      map(({ isAuthenticated }) => {
        // allow navigation if authenticated
        const currentUser = this.authenticationService.currentUserValue;
        if (isAuthenticated && currentUser && (!role || currentUser.role.indexOf(role)>-1 )) {
          return true;
        }
        
        // redirect if not authenticated
        if (role === "Customer" && isAuthenticated && currentUser)
          this.router.navigate(['/unauthorized'], { queryParams: { returnUrl: state.url} })
          .catch(error => {
            this.loggingService.logException(error);
          });
        else
          this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } })
          .catch(error => {
            this.loggingService.logException(error);
          });
          return false;
      })
    );
  }
}
